import { render, staticRenderFns } from "./SalesSummaryCards.vue?vue&type=template&id=28d41f98&scoped=true"
import script from "./SalesSummaryCards.vue?vue&type=script&lang=js"
export * from "./SalesSummaryCards.vue?vue&type=script&lang=js"
import style0 from "./SalesSummaryCards.vue?vue&type=style&index=0&id=28d41f98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d41f98",
  null
  
)

export default component.exports